import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../lib/auth-context';
import { Loader2 } from 'lucide-react';

export default function OAuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const access_token = params.get('access_token');
    const refresh_token = params.get('refresh_token');
    if (access_token) {
      localStorage.setItem('access_token', access_token);
      if (refresh_token) localStorage.setItem('refresh_token', refresh_token);
      // Decode basic info from token to store user
      try {
        const payload = JSON.parse(atob(access_token.split('.')[1]));
        const user = { id: payload.sub, email: payload.email, role: payload.role };
        localStorage.setItem('user', JSON.stringify(user));
      } catch {}
      navigate('/admin');
    } else {
      navigate('/login?error=oauth_failed');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBF7EF]">
      <div className="text-center space-y-3">
        <Loader2 className="w-8 h-8 animate-spin text-[#B89B5E] mx-auto" />
        <p className="text-sm text-[#5B616E]">Completing sign-in…</p>
      </div>
    </div>
  );
}
